<template>
  <router-view />
</template>

<script>
export default {}
</script>

<style>
/* Estilos generales si deseas */
</style>
